import { EventItem } from "types/user";

export const ASSIGNED_SEATING_BUY_FLOW = "assigned-seating";

export const eventBuyFlowIntent = (isAssignedSeatingEvent: boolean) =>
  isAssignedSeatingEvent ? ASSIGNED_SEATING_BUY_FLOW : true;

export const isAssignedSeatingBuyFlow = (value: unknown) =>
  value === ASSIGNED_SEATING_BUY_FLOW;

interface ShouldResumeEventBuyFlowParams {
  event?: EventItem;
  isEventBuyFlow: unknown;
  isMyProfile: boolean;
  isStripeCardsLoading: boolean;
  hasPreviousTicketCookie: boolean;
}

export const shouldResumeEventBuyFlow = ({
  event,
  isEventBuyFlow,
  isMyProfile,
  isStripeCardsLoading,
  hasPreviousTicketCookie,
}: ShouldResumeEventBuyFlowParams) => {
  return Boolean(
    event &&
      isEventBuyFlow &&
      !isMyProfile &&
      !isStripeCardsLoading &&
      !hasPreviousTicketCookie
  );
};

type EventBuyFlowResumeAction =
  | "restore-assigned-seat-selection"
  | "open-assigned-seat-picker"
  | "open-checkout";

interface GetEventBuyFlowResumeActionParams
  extends ShouldResumeEventBuyFlowParams {
  hasResumed: boolean;
  isAssignedSeatingEvent: boolean;
  isSeatMapLoading: boolean;
  shouldFetchSeatMap?: boolean;
}

export const getEventBuyFlowResumeAction = ({
  hasResumed,
  isAssignedSeatingEvent,
  isSeatMapLoading,
  shouldFetchSeatMap = isAssignedSeatingEvent,
  ...resumeParams
}: GetEventBuyFlowResumeActionParams): EventBuyFlowResumeAction | null => {
  if (
    hasResumed ||
    !shouldResumeEventBuyFlow(resumeParams) ||
    (shouldFetchSeatMap && isSeatMapLoading)
  ) {
    return null;
  }

  if (!isAssignedSeatingEvent) {
    return "open-checkout";
  }

  return isAssignedSeatingBuyFlow(resumeParams.isEventBuyFlow)
    ? "restore-assigned-seat-selection"
    : "open-assigned-seat-picker";
};
